import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getApiRequest } from '../../services/getApiRequest';


const getCouponCodeData = createAsyncThunk('api/Flight/pax/GetCouponData', (searchid, navigate) => {
    let ApiRequest = getApiRequest()
    return ApiRequest({
        url: "Flight/pax/GetCouponData",
        method: "post",
        data: {
            searchId: searchid,
        }
    })

        .then(function (response) {
            if (response.status == '200') {
                if (response.data.data) {
                    return response.data.data;
                }
            } else {
                navigate(process.env.REACT_APP_BASE_URL)
                return false;
            }
        })
        .catch(function (error) {

            console.log(error);
            navigate("/")
            return false;
        });
})


const couponCodeData = createSlice({
    name: 'CouponData',
    initialState: {
        isCouponApplied: false,
        error: "",
        isLoading: true,
        couponCode: "",
        combinationCouponDiscount: 0,
    },
    reducers: {
        setCouponCodeData: (state, action) => {
            const p = action.payload;
            if (p && typeof p === "object" && !Array.isArray(p)) {
                state.couponCode = p.couponCode ?? "";
                state.isCouponApplied = Boolean(p.isCouponApplied);
                state.combinationCouponDiscount =
                    parseFloat(p.combinationCouponDiscount || 0) || 0;
            } else if (p) {
                state.isCouponApplied = true;
                state.couponCode = p;
                state.combinationCouponDiscount = 0;
            } else {
                state.isCouponApplied = false;
                state.couponCode = "";
                state.combinationCouponDiscount = 0;
            }
            state.isLoading = false;
        }
    },
    extraReducers: {
        [getCouponCodeData.fulfilled]: (state, action) => {
            if (action.payload) {
                state.isLoading = false;
                state.couponCode = action.payload.couponCode;
                state.isCouponApplied = action.payload.isCouponApplied;
            }
        },
        [getCouponCodeData.pending]: state => {
            state.isLoading = false;
        },
        [getCouponCodeData.rejected]: state => {
            state.isLoading = false;
            state.error = "Coupon Code fetch error"
        }
    }
})

export const { setCouponCodeData } = couponCodeData.actions
export { getCouponCodeData };
export default couponCodeData.reducer